import * as types from "./mutation-types";
import _ from "lodash";

export default {
  [types.LIST_PERFIS](state, payload) {
    state.perfis_list = payload;
  },
  [types.SET_PERFIL](state, payload) {
    state.perfil = payload;
  },
  [types.LIST_CATEGORIAS](state, payload) {
    state.categorias_list = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};